import React, { useEffect, useState } from 'react';
import { addMonths, getMonth, getYear, setMonth, setYear } from 'date-fns';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { Ioption } from 'tradevan-ui/type';
import styled from '@emotion/styled';
import HelperText, { HelperTextProps } from 'tradevan-ui/Form/HelperText';
import ReactSelect from 'tradevan-ui/ReactSelect';
import { inputVal } from 'tradevan-ui/consts';
import Button from 'tradevan-ui/Button';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';

/** range array */
export const range = (start: number, end?: number, step = 1) => {
  const output = [];
  let startTemp = start;
  let endTemp = end;
  if (typeof endTemp === 'undefined') {
    startTemp = start;
    endTemp = 0;
  }
  for (let i = startTemp; i < endTemp; i += step) {
    output.push(String(i));
  }
  return output;
};

/** 取得年份 options */
export const getYearsRangeOptions = (
  minDate: Date,
  maxDate: Date,
  labelFunc = (str: string) => str,
) =>
  range(getYear(minDate), getYear(maxDate) + 1, 1).map((value) => ({
    value: String(value),
    label: labelFunc(value),
  }));
const StyledButton = styled(Button)({
  padding: '1px 6px',
  borderWidth: '1px',
  '&:focus': { boxShadow: 'none' },
});

export interface YearMonthHeaderProps
  extends ReactDatePickerCustomHeaderProps,
    HelperTextProps {
  years?: Ioption[];
  minDate: Date;
  maxDate: Date;
}

const YearMonthHeader = (props: YearMonthHeaderProps): JSX.Element => {
  const {
    minDate,
    maxDate,
    years = getYearsRangeOptions(minDate, maxDate),
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    error,
    helperText,
  } = props;

  const months = [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ].map((label, idx) => ({ value: String(idx), label }));

  const [localDate, setLocalDate] = useState(date);
  const [localDateStr, setLocalDateStr] = useState(date.toDateString());

  // date 物件會一再被更新，故改為監聽 date.toDateString()
  useEffect(() => {
    setLocalDateStr(date.toDateString());
  }, [date]);
  useEffect(() => {
    setLocalDate(date);
  }, [localDateStr]);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <HelperText error={error} helperText={helperText} />
      <div
        style={{
          // margin: 10,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <StyledButton
          variant={ButtonVariantEnum.none}
          endIcon={<i className="icon-common_left-24px" />}
          type="button"
          onClick={() => {
            setLocalDate(addMonths(localDate, -1));
            decreaseMonth();
          }}
          disabled={prevMonthButtonDisabled}
        />

        <ReactSelect
          className="MyDropdown"
          classNamePrefix="MyDropdown"
          onMenuOpen={() => {
            setTimeout(() => {
              const selectedEl = document.getElementsByClassName(
                'MyDropdown__option--is-selected',
              )[0];
              if (selectedEl) {
                selectedEl.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'start',
                });
              }
            }, 15);
          }}
          menuPortalTarget={document.querySelector('body')}
          value={inputVal(getYear(localDate))}
          onChange={(newValue) => {
            setLocalDate(setYear(localDate, Number(newValue)));
            changeYear(Number(newValue));
          }}
          options={years}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />

        <ReactSelect
          className="MyDropdown"
          classNamePrefix="MyDropdown"
          onMenuOpen={() => {
            setTimeout(() => {
              const selectedEl = document.getElementsByClassName(
                'MyDropdown__option--is-selected',
              )[0];
              if (selectedEl) {
                selectedEl.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'start',
                });
              }
            }, 15);
          }}
          menuPortalTarget={document.querySelector('body')}
          value={inputVal(getMonth(localDate))}
          onChange={(newValue) => {
            setLocalDate(setMonth(localDate, Number(newValue)));
            changeMonth(Number(newValue));
          }}
          options={months}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />

        <StyledButton
          startIcon={<i className="icon-common_right-24px" />}
          variant={ButtonVariantEnum.icon}
          type="button"
          onClick={() => {
            setLocalDate(addMonths(localDate, 1));
            increaseMonth();
          }}
          disabled={nextMonthButtonDisabled}
        />
      </div>
    </div>
  );
};

export default YearMonthHeader;
